:host {
  display: contents;
}

.spw-table-header {
  border: 1px solid var(--spw-color-themes-grey-grey-300);
  color: var(--spw-color-themes-grey-grey-800);
  font-size: 14px;
  text-align: left;
  padding: 16px;
  font-weight: 700;
  background: var(--spw-color-themes-grey-grey-100);

  border-top: none !important;
  border-bottom: none !important;
  box-shadow:
    inset 0 1px 0 var(--spw-color-themes-grey-grey-300),
    inset 0 -1px 0 var(--spw-color-themes-grey-grey-300);

  background-clip: padding-box;

  :host-context(.spw-table--is-sticky) & {
    position: sticky;
    top: 0;
    z-index: 20;
  }

  &--text-align-left {
    text-align: left;
  }
  &--text-align-center {
    text-align: center;
  }
  &--text-align-right {
    text-align: right;
  }
  &--vertical-align-top {
    vertical-align: top;
  }
  &--vertical-align-bottom {
    vertical-align: bottom;
  }
  &--vertical-align-middle {
    vertical-align: middle;
  }
}
